/**
 * FlorEasy — synchronisation des favoris (wishlist) via FieldsRaven.
 *
 * Lecture : synchrone via le seed metafield (voir snippet floreasy-favoris-raven).
 * Écriture : asynchrone via l'App Proxy FieldsRaven, avec anti-rebond.
 * Secours : si non connecté ou Raven non configuré, on reste en localStorage.
 */
(function (window) {
  'use strict';

  var KEY = 'wishlist-storage';
  var PUSH_DEBOUNCE_MS = 1200;
  var pushTimer = null;

  function getConfig() {
    return window.FlorEasyFavorisRavenConfig || {};
  }

  function isReady() {
    var cfg = getConfig();
    return !!(
      cfg.enabled &&
      cfg.auth &&
      cfg.auth.raven_id &&
      cfg.auth.raven_id !== 'TBD' &&
      cfg.auth.raven_mac &&
      cfg.auth.resource_id
    );
  }

  function readLocal() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function push(handles) {
    if (!isReady()) return Promise.resolve({ synced: false, reason: 'not_ready' });

    var cfg = getConfig();
    var auth = cfg.auth;
    var payload = {
      raven: {
        raven_id: String(auth.raven_id),
        resource_id: String(auth.resource_id),
        raven_mac: String(auth.raven_mac),
        value: JSON.stringify(handles || [])
      }
    };

    return fetch(cfg.endpoint || '/apps/raven/create_metafield', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json()
          .then(function (json) { return { status: response.status, json: json }; })
          .catch(function () { return { status: response.status, json: null }; });
      })
      .then(function (res) {
        if (!res || res.status !== 200) {
          console.warn('[FlorEasyFavoris] FieldsRaven:', res);
          return { synced: false, reason: 'raven_error', response: res };
        }
        return { synced: true };
      })
      .catch(function (err) {
        console.warn('[FlorEasyFavoris] réseau:', err);
        return { synced: false, reason: 'network' };
      });
  }

  /** Appelé après chaque ajout/retrait de favori (via global.js). */
  function onChange() {
    if (!isReady()) return;
    if (pushTimer) clearTimeout(pushTimer);
    pushTimer = setTimeout(function () {
      pushTimer = null;
      push(readLocal());
    }, PUSH_DEBOUNCE_MS);
  }

  function init() {
    var cfg = getConfig();
    // Au chargement, si des favoris locaux n'étaient pas dans le metafield.
    if (isReady() && cfg.pushNeededOnLoad) {
      push(readLocal());
    }
  }

  window.FlorEasyFavoris = {
    onChange: onChange,
    push: push,
    isReady: isReady,
    readLocal: readLocal
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
